import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import BillingRecordView from "./BillingRecordView";
import styles from "../../css/BillingManagement.module.css";

export default function BillingInputPage({
  selectedSessionId,
  sessions,
  currentSessionItems,
  resolvedStudentList,
  billingRecords,
  getBillingRecord,
  updateBillingRecord,
  updateBillingRecordsBulk,
  sessionItems,
  settingData,
  handleToastCenterTop,
  canCreate,
  canUpdate,
  canRead,
  canAccess,
}) {
  const { t } = useTranslation();
  const [selectedItem, setSelectedItem] = useState(null);

  useEffect(() => {
    setSelectedItem(null);
  }, [selectedSessionId]);

  if (!selectedSessionId) {
    return (
      <div className="text-muted mt-3">
        {t("billingManagement.inputPage.selectCourseHint") ||
          "과정과 기간을 선택하여 항목을 불러오세요."}
      </div>
    );
  }

  const handleItemClick = (si) => {
    setSelectedItem((prev) =>
      String(prev?.id) === String(si.id) ? null : si,
    );
  };

  return (
    <div>
      <div className={styles.itemChipGrid}>
        {currentSessionItems.map((si) => {
          const isActive = String(selectedItem?.id) === String(si.id);
          return (
            <button
              key={si.id}
              className={`btn btn-sm ${isActive ? "btn-primary" : "btn-outline-secondary"} ${styles.itemChip}`}
              onClick={() => handleItemClick(si)}
            >
              <span className={styles.itemChipName}>{si.item_name}</span>
              <span className={styles.itemChipAmount}>
                {(() => {
                  const n = si.default_amount;
                  if (n == null || n === "") return "—";
                  const num = Number(n);
                  if (!Number.isFinite(num)) return "—";
                  return `${num.toLocaleString()}원`;
                })()}
              </span>
            </button>
          );
        })}
      </div>
      {currentSessionItems.length === 0 && (
        <div className="text-muted mt-2">
          {t("billingManagement.inputPage.noItemsInPeriod") ||
            "해당 기간에 만들어진 항목이 없습니다."}
        </div>
      )}

      {selectedItem && (
        <div className="mt-3">
          <BillingRecordView
            selectedItem={selectedItem}
            selectedSessionId={selectedSessionId}
            sessions={sessions}
            resolvedStudentList={resolvedStudentList}
            billingRecords={billingRecords}
            getBillingRecord={getBillingRecord}
            updateBillingRecord={updateBillingRecord}
            updateBillingRecordsBulk={updateBillingRecordsBulk}
            sessionItems={sessionItems}
            settingData={settingData}
            handleToastCenterTop={handleToastCenterTop}
            canCreate={canCreate}
            canUpdate={canUpdate}
            canRead={canRead}
            canAccess={canAccess}
          />
        </div>
      )}
    </div>
  );
}
